module.exports = __webpack_public_path__ + "static/MADE_Evolve_Sans_Regular-a53c8e6e910cbed1f7a80f82475f5b1a.woff";